module.exports = __webpack_public_path__ + "img/appAsset--purchase-ax.5fb90288.svg";